export default __webpack_public_path__ + "static/media/s22e01_c.3c3dd5c7.png";